import { SAVED_TECH_CHART_VIEW_STATE_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
import { TECH_CHART } from 'NewAngular/constants/core.constants';
import { BaseSavedItemService } from 'NewAngular/features/components/saved-items/services/common-services/base-saved-item.service';
import { SavedChartService } from 'NewAngular/features/components/saved-items/services/common-services/saved-chart.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { convertNestedBooleanToString } from 'NewAngular/utils/state-utils';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import { TechChartUrlSerializer } from 'ChartApp/ts/features/tech-chart-page-shared/state/tech-chart.serializer';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/saved-items/services/common-services/saved-chart.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "NewAngular/services/core/urls.service";
export class SavedTechChartService extends BaseSavedItemService {
    constructor(savedChartService, ajaxService, urlsService) {
        super();
        this.savedChartService = savedChartService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getItems(includeLegacy) {
        return this.savedChartService.getItems(TECH_CHART, includeLegacy);
    }
    getFolderableItems(params) {
        return this.ajaxService.getDataObserveBody(this.urlsService.CHARTS.TECH_CHART_COLLECTION, params);
    }
    deleteItem(chartId) {
        return this.savedChartService.deleteItem(chartId, TECH_CHART);
    }
    updateItem(chartId, putParams) {
        const flattenedParams = formFlattenedObject(putParams, SAVED_TECH_CHART_VIEW_STATE_KEYS, TechChartUrlSerializer);
        // Convert booleans to strings because the backend expects booleans to be in the format of strings 'True' or
        // 'False'.
        convertNestedBooleanToString(flattenedParams);
        return this.savedChartService.updateItem(chartId, flattenedParams, TECH_CHART);
    }
    createItem(postParams, chartName) {
        const flattenedParams = formFlattenedObject({ ...postParams, chartName }, SAVED_TECH_CHART_VIEW_STATE_KEYS, TechChartUrlSerializer);
        return this.savedChartService.createItem(flattenedParams, TECH_CHART);
    }
    getErrorMessage(error) {
        return this.savedChartService.getErrorMessage(error);
    }
}
SavedTechChartService.ɵfac = function SavedTechChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedTechChartService)(i0.ɵɵinject(i1.SavedChartService), i0.ɵɵinject(i2.AjaxService), i0.ɵɵinject(i3.UrlsService)); };
SavedTechChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedTechChartService, factory: SavedTechChartService.ɵfac, providedIn: 'root' });
